// frontend/src/pages/OAuthCallbackPage.jsx

import React from 'react';
import OAuthCallbackHandler from '../components/OAuthCallbackHandler';
import routes from '../config/routes';
import PageTitle from '../components/PageTitle';

/**
 * OAuth Callback Page
 * Dedicated page for handling OAuth authentication callbacks
 */
function OAuthCallbackPage() {
  const handleSuccess = result => {
    console.log('OAuth authentication successful:', result);
    // Additional success handling can be added here
  };

  const handleError = error => {
    console.error('OAuth authentication failed:', error);
    // Additional error handling can be added here
  };

  return (
    <>
      <PageTitle title="Completing Authentication" />
      <OAuthCallbackHandler
        onSuccess={handleSuccess}
        onError={handleError}
        successRedirect="/dashboard"
        errorRedirect={routes.login()}
      />
    </>
  );
}

export default OAuthCallbackPage;
